import { useEffect, useState } from "react";
import axios from "axios";
import { Leaf } from "lucide-react";
import { services } from "./services_data";
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

export default function Services() {
  // const [services, setServices] = useState([]);
  // const [loading, setLoading] = useState(true);
  const loading = false;
  // useEffect(() => {
  //   const fetchServices = async () => {
  //     try {
  //       const response = await axios.get(`${API}/services`);
  //       setServices(response.data);
  //     } catch (error) {
  //       console.error('Error fetching services:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchServices();
  // }, []);

  return (
    <div className="min-h-screen py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1
            className="text-5xl md:text-6xl font-heading font-bold text-[#2D3436] mb-4"
            data-testid="services-page-title"
          >
            Services & <span className="text-primary">Products</span>
          </h1>
          <p className="text-lg text-[#636E72] max-w-3xl mx-auto">
            Authentic Ayurvedic products and treatments for holistic wellness
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="inline-block w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
            data-testid="services-grid"
          >
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-white p-8 rounded-xl border border-border/50 hover:border-primary/30 transition-all duration-300 hover:bg-[#F9F7F2] group"
                data-testid={`service-card-${service.id}`}
              >
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                  <Leaf className="text-primary" size={32} />
                </div>
                <h3 className="text-xl font-heading font-semibold text-[#2D3436] mb-3">
                  {service.name}
                </h3>
                <p className="text-[#636E72] leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        )}

        <div className="mt-16 bg-gradient-to-br from-primary/5 to-secondary/5 p-12 rounded-2xl">
          <h2 className="text-3xl font-heading font-semibold text-[#2D3436] mb-6 text-center">
            About Our Products
          </h2>
          <div className="space-y-4 text-[#636E72] leading-relaxed max-w-3xl mx-auto">
            <p>
              All our products are prepared following traditional Ayurvedic
              methods using high-quality, natural ingredients. Each product is
              carefully formulated to address specific health concerns and
              promote overall wellness.
            </p>
            <p>
              These products complement our consultation services and are
              recommended based on individual health assessments by our
              certified doctors.
            </p>
            <p className="text-center mt-8 text-sm">
              <strong>Note:</strong> Product availability and recommendations
              will be discussed during consultation
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
